import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/firestore';

Vue.config.productionTip = false

let app = '';
const config = {
  apiKey: "AIzaSyAUvXSpRifxYR0nwNkJ_pDem_oou_YPkfw",
  projectId : "opensourcejobs-db",
//   authDomain: "osj.netlify.com"
}

firebase.initializeApp(config);

const db = firebase.firestore();

Vue.prototype.$fb = {
    db : db,
    users : db.collection( "users" ),
    records : db.collection( "jobs" )
};

firebase.auth().onAuthStateChanged( () => {
    if (!app) {
        app = new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app');
        
        const currentUser = firebase.auth().currentUser;
        // set initial state
        if (currentUser !== null) {
            store.dispatch('setInitial', currentUser);
        }
    }
});